/**
 * @module ol/ViewProperty
 */
/**
 * @enum {string}
 */
export default {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};
//# sourceMappingURL=ViewProperty.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/ViewProperty.js
// module id = 248
// module chunks = 1